// ===== helpers =====
const debounce = (fn, ms = 400) => {
  let t; const d = (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); };
  d.cancel = () => clearTimeout(t);
  d.flush = (...a) => { clearTimeout(t); fn(...a); };
  return d;
};
const jsonStable = (arr) =>
  JSON.stringify([...arr].sort((a, b) => a.key.localeCompare(b.key) || (a.qty - b.qty)));

async function fetchSectionHtml(id) {
  // 1) JSON sections API
  try {
    const r = await fetch(`/?sections=${encodeURIComponent(id)}`, { credentials: 'same-origin' });
    if (r.ok) {
      const data = await r.json();
      if (data && data[id]) return data[id];
    }
  } catch {}

  // 2) fallback section_id
  try {
    const r = await fetch(`${window.location.pathname}?section_id=${encodeURIComponent(id)}`, {
      credentials: 'same-origin'
    });
    if (r.ok) return await r.text();
  } catch {}

  return null;
}

function updateCartBubbleCount(count) {
  const bubbles = document.querySelectorAll('.cart-bubble');
  bubbles.forEach((bubble) => {
    const countEl = bubble.querySelector('.cart-bubble__text-count');
    const srEl = bubble.querySelector('.visually-hidden');

    if (countEl) countEl.textContent = String(count);
    if (srEl) srEl.textContent = `Artikel im Warenkorb insgesamt: ${count}`;

    if (count > 0) {
      bubble.style.removeProperty('display');
      bubble.removeAttribute('hidden');
      bubble.setAttribute('aria-hidden', 'false');
    } else {
      bubble.setAttribute('aria-hidden', 'true');
      bubble.style.display = 'none';
    }
  });
}

function syncDrawerEmptyStateFromCartCount(count) {
  const isEmpty = Number(count || 0) === 0;

  document.querySelectorAll('.cart-drawer__dialog').forEach((el) => {
    el.classList.toggle('cart-drawer--empty', isEmpty);
  });

  document.querySelectorAll('.cart-drawer').forEach((el) => {
    el.classList.toggle('cart-drawer--empty', isEmpty);
  });
}

async function getCartJson() {
  const r = await fetch('/cart.js', {
    credentials: 'same-origin',
    headers: { Accept: 'application/json' }
  });
  if (!r.ok) throw new Error('cart_json_failed');
  return r.json();
}

async function refreshCartDrawer() {
  const drawer = document.querySelector('cart-drawer-component');
  const itemsComp = drawer?.querySelector('.cart-items-component');
  const secId = itemsComp?.dataset.sectionId;

  // Даже если drawer сейчас не найден (например, на /cart), просто обновим bubble + state
  if (!secId) {
    try {
      const cart = await getCartJson();
      updateCartBubbleCount(cart.item_count || 0);
      syncDrawerEmptyStateFromCartCount(cart.item_count || 0);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
    } catch {}
    return;
  }

  // 1) Тянем свежую разметку секции drawer
  const html = await fetchSectionHtml(secId);
  if (html) {
    const tmp = document.createElement('div');
    tmp.innerHTML = html;

    // Меняем не только items, но и shell-состояние/summary/header
    const currentDialog = drawer.querySelector('.cart-drawer__dialog');
    const nextDialog = tmp.querySelector('.cart-drawer__dialog');

    const currentHeader = drawer.querySelector('.cart-drawer__header');
    const nextHeader = tmp.querySelector('.cart-drawer__header');

    const currentContent = drawer.querySelector('.cart-drawer__content');
    const nextContent = tmp.querySelector('.cart-drawer__content');

    if (currentDialog && nextDialog) {
      // критично для cart-drawer--empty
      currentDialog.className = nextDialog.className;
    }

    if (currentHeader && nextHeader) {
      currentHeader.replaceWith(nextHeader);
    }

    if (currentContent && nextContent) {
      currentContent.replaceWith(nextContent);
    } else {
      // fallback на старую логику
      const currentItems = drawer.querySelector('.cart-items-component');
      const nextItems = tmp.querySelector('.cart-items-component');
      if (currentItems && nextItems) currentItems.replaceWith(nextItems);
    }
  }

  // 2) Синхронизируем bubble + empty state по фактическому cart.json
  try {
    const cart = await getCartJson();
    updateCartBubbleCount(cart.item_count || 0);
    syncDrawerEmptyStateFromCartCount(cart.item_count || 0);
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
  } catch {}

  // 3) Восстановим гидратацию конфигураторов коробок после перерендера
  hydrateGiftboxes();

  // 4) Событие для остального JS
  document.dispatchEvent(new CustomEvent('cart:refresh'));
}
window.refreshCartDrawer = refreshCartDrawer;

// ===== greeting attribute autosave =====
const saveGreeting = debounce(async () => {
  const el = document.getElementById('cart-greeting-message');
  if (!el) return;
  await fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ attributes: { greeting_message: el.value.trim() || '' } })
  });
  document.dispatchEvent(new CustomEvent('cart:refresh'));
}, 300);
document.addEventListener('input', (e) => {
  if (e.target && e.target.id === 'cart-greeting-message') saveGreeting();
}, true);
document.addEventListener('blur', (e) => {
  if (e.target && e.target.id === 'cart-greeting-message') saveGreeting.flush();
}, true);

// ===== hydrate values from saved properties =====
function hydrateGiftboxes(root = document) {
  root.querySelectorAll('.giftbox-config').forEach((box) => {
    const giftedRaw = box.dataset.gifted || '[]';
    let list = [];
    try { list = JSON.parse(giftedRaw); } catch { list = []; }
    const byKey = new Map(list.map(x => [x.key, x.qty]));
    let picked = 0;
    box.querySelectorAll('.giftbox-row').forEach((row) => {
      const key = row.dataset.bottleKey;
      const input = row.querySelector('.giftbox-input');
      const val = byKey.get(key) || 0;
      input.value = String(val);
      picked += val;
    });
    const pickedEl = box.querySelector('[data-picked]');
    if (pickedEl) pickedEl.textContent = picked;
    const err = box.querySelector('.giftbox-error');
    if (err) err.hidden = picked <= Number(box.dataset.capacity || 1);
  });
}
window.hydrateGiftboxes = hydrateGiftboxes;
document.addEventListener('DOMContentLoaded', () => hydrateGiftboxes());

// ===== save composition (handle key rotation via _gift_group) =====
const saving = new WeakSet();
const debouncedSaveByBox = new WeakMap();

async function saveBox(box) {
  if (saving.has(box)) return false;
  const cap = Number(box.dataset.capacity || 1);
  const rows = [...box.querySelectorAll('.giftbox-row')];
  const errorEl = box.querySelector('.giftbox-error');
  const statusEl = box.querySelector('.giftbox-status');

  let sum = 0;
  const gifted = [];
  const contents = [];
  rows.forEach((row) => {
    const input = row.querySelector('.giftbox-input');
    let qty = Number(input.value || 0);
    const max = Number(row.dataset.max || 0);
    if (isNaN(qty) || qty < 0) qty = 0;
    if (qty > max) qty = max;
    if (qty > 0) {
      const key = row.dataset.bottleKey;
      const name = row.querySelector('.giftbox-name').textContent.trim();
      gifted.push({ key, qty });
      contents.push(`${name} x${qty}`);
      sum += qty;
    }
  });

  if (sum > cap) { if (errorEl) errorEl.hidden = false; return false; }
  if (errorEl) errorEl.hidden = true;

  const nextState = jsonStable(gifted);
  const prevState = box.dataset.giftedStable || '[]';
  if (nextState === prevState) {
    const pickedEl = box.querySelector('[data-picked]'); if (pickedEl) pickedEl.textContent = sum;
    return true;
  }

  saving.add(box);

  const payload = {
    id: box.dataset.giftLineKey,
    properties: {
      _gift_box: true,
      _capacity: cap,
      _gift_group: box.dataset.giftGroup || '',
      _gifted: JSON.stringify(gifted),
      _gift_contents: contents.join('; ')
    }
  };

  let cart;
  try {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    });
    if (!res.ok) throw new Error('change_failed');
    cart = await res.json();
  } catch (e) {
    saving.delete(box);
    alert('Не удалось сохранить состав коробки. Попробуйте ещё раз.');
    return false;
  }

  const ggroup = box.dataset.giftGroup || '';
  const giftItem = (cart.items || []).find(i =>
    i.properties && String(i.properties._gift_group || i.properties.gift_group || '') === ggroup
  );

  if (giftItem) {
    box.dataset.giftLineKey  = giftItem.key;
    box.dataset.gifted       = giftItem.properties?._gifted || giftItem.properties?.gifted || '[]';
    try { box.dataset.giftedStable = jsonStable(JSON.parse(box.dataset.gifted)); } catch { box.dataset.giftedStable = '[]'; }

    const pickedEl = box.querySelector('[data-picked]'); if (pickedEl) pickedEl.textContent = sum;
    const currentText = box.querySelector('.giftbox-current');
    if (currentText) {
      const gc = giftItem.properties?._gift_contents || giftItem.properties?.gift_contents || '';
      currentText.textContent = gc ? `Jetzt in Geschenkverpackung: ${gc}` : 'Jetzt in Geschenkverpackung: ';
    }
  } else {
    await refreshCartDrawer();
  }

  if (statusEl) { statusEl.hidden = false; setTimeout(() => { statusEl.hidden = true; }, 1200); }
  saving.delete(box);
  document.dispatchEvent(new CustomEvent('cart:refresh'));
  return true;
}

// +/-
document.addEventListener('click', (e) => {
  const stepBtn = e.target.closest('.giftbox-step'); if (!stepBtn) return;
  const box = stepBtn.closest('.giftbox-config'); const row = stepBtn.closest('.giftbox-row');
  const input = row.querySelector('.giftbox-input');

  const max = Number(row.dataset.max || 0);
  const cap = Number(box.dataset.capacity || 1);
  const inputs = [...box.querySelectorAll('.giftbox-input')];

  const currentSum = inputs.reduce((s, el) => s + (Number(el.value || 0)), 0);
  let val = Number(input.value || 0);
  if (stepBtn.dataset.step === 'inc') { if (val < max && currentSum < cap) val += 1; }
  else { if (val > 0) val -= 1; }
  input.value = String(val);

  const newSum = inputs.reduce((s, el) => s + (Number(el.value || 0)), 0);
  const pickedEl = box.querySelector('[data-picked]'); if (pickedEl) pickedEl.textContent = newSum;
  const err = box.querySelector('.giftbox-error'); if (err) err.hidden = newSum <= cap;

  let saver = debouncedSaveByBox.get(box);
  if (!saver) { saver = debounce(() => saveBox(box), 500); debouncedSaveByBox.set(box, saver); }
  saver();
}, true);

// manual input (readOnly, но на всякий случай)
document.addEventListener('input', (e) => {
  const input = e.target.closest('.giftbox-input'); if (!input) return;
  const box = input.closest('.giftbox-config'); const row = input.closest('.giftbox-row');
  const max = Number(row?.dataset.max || 0);
  let v = Number(input.value || 0);
  if (isNaN(v) || v < 0) v = 0; if (v > max) v = max; input.value = String(v);

  const cap = Number(box.dataset.capacity || 1);
  const sum = [...box.querySelectorAll('.giftbox-input')].reduce((s, el) => s + (Number(el.value || 0)), 0);
  const pickedEl = box.querySelector('[data-picked]'); if (pickedEl) pickedEl.textContent = sum;
  const err = box.querySelector('.giftbox-error'); if (err) err.hidden = sum <= cap;

  let saver = debouncedSaveByBox.get(box);
  if (!saver) { saver = debounce(() => saveBox(box), 600); debouncedSaveByBox.set(box, saver); }
  saver();
}, true);

document.addEventListener('cart:refresh', () => setTimeout(() => hydrateGiftboxes(), 0));
